import React from 'react';
import { useTranslation } from 'react-i18next';
import { FormType } from '../../backend/openapi/api-types';
import { AuthenticatedForm } from './authenticated-form';

export const ArticleNotFoundForm: React.FC = () => {
  const { t } = useTranslation();

  return (
    <AuthenticatedForm documentTitle={t('form.articleNotFound.documentTitle')} formType={FormType.articleNotFound} />
  );
};
